<script>
import BOForm from '../../baseComponents/boForm'
import { SET_BOT, SUCCESS } from '../../variables'

export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true },
				{
					label: 'Contact',
					value: 'contact',
					type: 'sub-doc',
					items: [
						{ label: 'Prénom', value: 'firstName', type: 'text' },
						{ label: 'Nom', value: 'lastName', type: 'text' },
						{ label: 'Email', value: 'mail', type: 'text' },
						{ label: 'Telephone', value: 'phone', type: 'text' }
					]
				},
				{
					label: 'Address',
					value: 'address',
					type: 'sub-doc',
					items: [
						{ label: 'Rue', value: 'street', type: 'text' },
						{ label: 'Ville', value: 'city', type: 'text' },
						{ label: 'Code postal', value: 'postalCode', type: 'text' },
						{ label: 'Pays', value: 'country', type: 'text' }
					]
				}
			]
		}
	},
	methods: {
		async post() {
			this.model.bot = this.$store.getters.bot._id
			await this.axios.post('userGroups', this.model)
			// dirty update of store.bot.userGroups
			this.$store.dispatch(SET_BOT, this.model.bot)
			this.$emit('userGroupCreated')
		},
		async put() {
			await this.axios.put('userGroups/' + this.model._id, this.model)
			// dirty update of store.bot.userGroups
			this.$store.dispatch(SET_BOT, this.model.bot)
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/userGroups/userGroup.form.vue